export default "__VITE_ASSET__DQSk8dgT__"